import { JargonTranslation } from './jargonTypes'

export const esCA: JargonTranslation = {
  abnEntity: 'un número de empresa',
  abn: 'Número de Empresa',
  abnLowercase: 'número de empresa',
  abnSearchName: 'Agencia Tributaria de Canadá',
  abns: 'Números de Empresa',
  abnsLowercase: 'números de empresa',
  companyInduction: 'Orientación de la Compañía',
  companyInductions: 'Orientaciones de la Compañía',
  defect: 'Defecto',
  defects: 'Defectos',
  drawing: 'Dibujo',
  drawings: 'Dibujos',
  favourite: 'Favorito',
  favourites: 'Favoritos',
  induct: 'Orientar',
  inducts: 'Orienta',
  inducted: 'Orientado',
  inducting: 'Orientando',
  induction: 'Orientación',
  inductions: 'Orientaciones',
  itp: 'ITP',
  itps: 'ITPs',
  people: 'Personal',
  peoples: 'Personal',
  preStart: 'Aviso',
  preStarts: 'Avisos',
  project: 'Proyecto',
  projects: 'Proyectos',
  projectHoursBudget: 'Presupuesto de Horas del Proyecto',
  projectHoursBudgets: 'Presupuestos de Horas del Proyecto',
  placeholderAddress: '456 Queen St W, Toronto, ON M5V 2B6',
  placeholderProjectName: '456 Queen St W',
  placeholderPhoneNumber: '250 555 5555',
  register: 'Registro',
  registers: 'Registros',
  sdsLibrary: 'Biblioteca de HDS',
  sdsLibraries: 'Bibliotecas de HDS',
  signOn: 'Registro de entrada',
  signOns: 'Registros de entrada',
  siteInduction: 'Orientación de Obra',
  siteInductions: 'Orientaciones de Obra',
  siteDiary: 'Registro Diario',
  siteDiaries: 'Registros Diarios',
  staff: 'Personal',
  staffs: 'Personal',
  subcontractor: 'Empresa',
  subcontractors: 'Empresas',
  swms: 'JHA',
  swmss: 'JHAs',
  swmsFullTitle: 'Evaluación de Riesgos de Nivel de Campo',
  ticket: 'Certificación',
  tickets: 'Certificaciones',
  timesheet: 'Hoja de Tiempo',
  timesheets: 'Hojas de Tiempo',
  worker: 'Trabajador',
  workers: 'Trabajadores',
}
